/*
*  Services Core module.
*
*  Provides JS services building blocks.
* */


export function HTTPService () {

    return Object.freeze({
        delete: _delete,
        get,
        post,
        put
    });

    function get(url) {
        return $.getJSON(url)
    }

    function post({url, data}) {
        return unsafe({
            url: url,
            type: 'POST',
            payload: JSON.stringify(data),
            contentType: 'application/json'
        })
    }

    function put({url, data}) {
        return unsafe({
            url: url,
            type: 'PUT',
            payload: JSON.stringify(data),
            contentType: 'application/json'
        })
    }

    function _delete(url) {
        return unsafe({
            url: url,
            type: 'DELETE',
            payload: '',
            contentType: 'application/json'
        })
    }

    function unsafe({url, type, payload, contentType}) {
        return $.ajax({
            url: `${url}/`,
            type: type,
            contentType: contentType,
            data: payload
        })
    }
}


export function APIService({version, namespace, http=HTTPService(), host=''}) {

    const filterSet = {
        'in': '__in',
        'gt': '__gt',
        'lt': '__lt',
        'contains': '__contains',
        'eq': ''
    };

    const API = `${host}/${version}/${namespace}`;

    let query = {
        total: 0,
        pages: 0,
        current: null,
        next: null,
        prev: null,
        init: false,
        filtering: [],
        sorting: [],
        search: '',
        bound: {},
        knn: {},
        radius: {},
        sortedBound: {}
    };

    return Object.freeze({
        create,
        retrieve,
        update,
        delete: _delete,
        list,
        getState,
        set,
        nextPage,
        prevPage,
        hasNext,
        hasPrev,
    });

    function list({filtering=[], sorting=[], sortedBound={}, search='', knn={}}) {

        let actions = [
            compileFiltering(filtering),
            compileSorting(sorting),
            compileSortedBound(sortedBound),
            compileKnn(knn),
            compileSearch(search)
        ].filter(Boolean).join('&');

        return http.get(API + (!!actions ? `?${actions}` : '')).then((resp) => {
            set({
                filtering: filtering,
                sorting: sorting,
                sortedBound:sortedBound,
                knn: knn,
                search: search,
                total: resp.total,
                pages: resp.pages,
                current: resp.current_page,
                next: resp.next,
                prev: resp.prev,
                init: true,
            });
            return resp
        });
    }

    function create(payload) {
        return http.post({
            url: API,
            data: payload
        })
    }

    function retrieve({id}) {
        return http.get(API + `/${id}`)
    }

    function update({uri, payload}) {
        return http.put({
            url: `${API}/${uri}`,
            data: payload,
        })
    }

    function _delete({id}) {
        return http.delete(API + `/${id}`)
    }

    function getState() {
        return query
    }

    function set(queryUpdates) {
        query = Object.assign(query, queryUpdates);
    }

    function parseFilter(filter) {
        return `${filter.name}${filterSet[filter.operator]}=${Array.isArray(filter.value) ? filter.value.join(','): filter.value}`
    }

    function parseSorting(sorting) {
        return `${sorting.direction === 'ASC' ? '' : '-' }${sorting.sorter}`
    }

    function compileFiltering(filters) {
        let filtering = filters.map(parseFilter);
        return filtering.join('&')
    }

    function compileSearch(search) {
        return !!search ? `_search=${search}` : null
    }

    function compileSorting(sorters) {

        let sorting = sorters.map(parseSorting);

        return !!sorting.join(',') ? `_sort=${sorting.join(',')}` : null
    }

    function compileKnn({lat, lng, limit}) {
        return !!(lat && lng && limit) ? `knn=${JSON.stringify({lat: lat, lng: lng, limit: limit})}` : null
    }

    function compileSortedBound({sw_lat, sw_lng, ne_lat, ne_lng, sort}) {
        return !!sw_lat ? `sorted_bound=${JSON.stringify({sw_lat, sw_lng, ne_lat, ne_lng, sort})}`: null
    }

    function nextPage() {
        if (!!query.next) {

            return http.get(query.next).then((resp) => {
                set({
                    next: resp.next,
                    prev: resp.prev,
                    current: resp.current_page
                });
                return resp
            })
        }
    }

    function prevPage() {
        if (!!query.prev) {

            return http.get(query.prev).then((resp) => {
                set({
                    next: resp.next,
                    prev: resp.prev,
                    current: resp.current_page
                });
                return resp
            })
        }
    }

    function hasNext() {
        return !!query.next
    }

    function hasPrev() {
        return !!query.prev
    }

}


// WEBPACK FOOTER //
// ./avr_eshop/frontend/services/core.es6